import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      console.error('No autorizado. Redirigiendo al login...');
    }
    if (!error.response) {
      console.error('Servidor no disponible. Verifica tu conexión.');
    }
    return Promise.reject(error);
  }
);

export default api;
